import { CheckboxOptionType, RadioChangeEvent } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ALL_KEY } from "../../components/CustomRadioButton/enumerations/enumerations";

import { FaqContainer } from "./components";
import { FaqCategoryResponse, FaqProps } from "./data";
import { useGetFaq, useGetFaqCategory } from "./hooks/faq.hooks";

const Faq: React.FC<FaqProps> = () => {
  const { t } = useTranslation();
  const { data: faqList, isLoading: loadingList } = useGetFaq({});
  const { data: category, isLoading: loadingCategory } = useGetFaqCategory({});
  const [options, setOptions] = useState<
    (string | number | CheckboxOptionType<any>)[]
  >([]);
  const [selectedCategory, setSelectedCategory] = useState<string | number>(
    ALL_KEY
  );

  const onChange = (e: RadioChangeEvent) => {
    setSelectedCategory(e.target.value);
  };

  useEffect(() => {
    if (!category) return;
    setOptions(
      category.map((category: FaqCategoryResponse) => {
        return {
          value: category.id,
          label: t([`${category.name}`]),
        };
      })
    );
  }, [category]);

  return (
    <FaqContainer
      options={options}
      selectedCategory={selectedCategory}
      onChange={onChange}
      loadingCategory={loadingCategory}
      loadingList={loadingList}
      faqList={faqList}
    />
  );
};

export default Faq;
